import React from 'react';
export function Footer() {
  return <footer className="bg-brand-plum text-white/60 py-12 px-4 text-sm text-center" data-id="element-140">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-141">
        <div className="space-y-4" data-id="element-142">
          <p className="font-bold text-white/80 text-base" data-id="element-143">
            AVISO LEGAL IMPORTANTE
          </p>
          <p data-id="element-144">
            Este producto no garantiza resultados específicos. Los testimonios y
            ejemplos mostrados son resultados excepcionales, que no aplican al
            comprador promedio y no pretenden representar ni garantizar que
            alguien logrará los mismos o similares resultados. El éxito de cada
            individuo depende de su dedicación, deseo y motivación.
          </p>
          <p data-id="element-145">
            Este material tiene fines exclusivamente educativos, espirituales y
            de desarrollo personal. No constituye asesoramiento médico,
            psicológico, financiero ni profesional de ningún tipo. Si necesitas
            ayuda profesional, por favor consulta a un especialista cualificado.
          </p>
          <p data-id="element-146">
            Este sitio no es parte del sitio web de Facebook™ o Facebook™ Inc.
            Además, este sitio NO está respaldado por Facebook™ de ninguna
            manera. FACEBOOK™ es una marca registrada de FACEBOOK™, Inc.
          </p>
          <p data-id="element-147">
            El pago es procesado de forma 100% segura a través de Hotmart.
            Hotmart es una plataforma de distribución de productos digitales y
            no tiene responsabilidad editorial sobre el contenido del producto.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 pt-8 border-t border-white/10" data-id="element-148">
          <a href="#" className="hover:text-white transition-colors" data-id="element-149">
            Términos de Servicio
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-150">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-151">
            Contacto
          </a>
        </div>

        <p className="pt-4" data-id="element-152">
          © 2026 La Abu Aurora. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}